import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const selectAllOrganizations = (state: RootState) => state.organization;

export const allTemplatesSelector = createSelector(
  selectAllOrganizations, (state) => state,
);
